import { render } from "./BannerSlotDetailButtonType.vue?vue&type=template&id=8280605c&scoped=true&ts=true"
import script from "./BannerSlotDetailButtonType.vue?vue&type=script&lang=ts"
export * from "./BannerSlotDetailButtonType.vue?vue&type=script&lang=ts"

import "./BannerSlotDetailButtonType.vue?vue&type=style&index=0&id=8280605c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8280605c"]])

export default __exports__